import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { StateService } from '../services/state.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private stateService: StateService,
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Obtener los roles requeridos desde la configuración de la ruta
    const requiredRoles = route.data['roles'] as string[];

    // Si no se especifican roles requeridos, permitir el acceso
    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }

    // Obtener los roles del usuario
    const userRoles = this.authService.getUserRoles();

    // Si el usuario no tiene roles, denegar el acceso
    if (!userRoles || userRoles.length === 0) {
      this.router.navigate(['/']);
      return false;
    }

    // Verificar si el usuario tiene al menos uno de los roles requeridos
    const hasRequiredRole = requiredRoles.some((role) => userRoles.includes(role));

    if (!hasRequiredRole) {
      // Redirigir a una página de acceso denegado o a la raíz
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
